import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Menu, Switch, Typography } from "antd";
import { Header } from "antd/lib/layout/layout";
import styled from "styled-components";
const { Search } = Input;

export const JulebHeader = styled(Header)`
  background: var(--juleb-color-primary);
  padding: 0;
  flex: 0.1;
`;

export const JulebSearch = styled(Search)`
  width: 100%;
  border-radius: 30px;
`;

export const JulebAwesomeIcon = styled(FontAwesomeIcon)`
  margin-right: 5px;
`;

export const JulebAwesomeButton = styled(FontAwesomeIcon)`
  cursor: pointer;
  margin-right: 5px;
  &:hover {
    color: var(--juleb-color-primary);
  }
`;

export const StyledSwitch = styled(Switch)`
  margin: 15px 22px;
  width: 60px;
`;

export const StyleMenuItem = styled(Menu.Item)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
`;

export const StyledTypographyLink = styled(Typography.Link)`
  position: relative;
  bottom: 32px;
  padding: 3px;
  right: 10px;
  float: right;
  font-size: 15px;
`;

export const TableButton = styled(Button)`
  margin: auto;
  color: #a2a2a9;
`;

export const SubmenuPointer = styled(FontAwesomeIcon)`
  padding-top: 15px;
  float: right;
  font-size: 0.8em;
`;
